import React from 'react';
import PropTypes from 'prop-types';
import AccordionSection from './accordionSection';

class SkuFilter extends React.Component {
  updateSkus(value) {
    /* eslint-disable no-useless-escape */
    const str = `(\"${value.trim().replace(/['"]+/g, '').split(/[\s,;\t\n]+/).join('\" OR \"')}\")`;
    /* eslint-enable no-useless-escape */
    this.props.updateFilters(str);
  }

  render() {
    return (
      <AccordionSection title={bfTranslate("SKU Search")}>
        <React.Fragment>
          <div className="flex-row">
            <div className="filter-search-row sku">
              <span>{bfTranslate("Terms")}:</span>
              <div className="sku-search-container">
                <span className="bff-search" />
                <textarea
                  rows={3}
                  onChange={(e) => this.updateSkus(e.target.value)}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      </AccordionSection>
    );
  }
}

SkuFilter.propTypes = {
  updateFilters: PropTypes.func.isRequired,
};

export default SkuFilter;
